import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import { RouteObject } from "react-router";

import SidebarLayout from "src/layouts/SidebarLayout";
import BaseLayout from "src/layouts/BaseLayout";

import SuspenseLoader from "src/components/SuspenseLoader";
import ProtectedRoute from "./ProtectedRoute";
import BatchUpload from "./content/applications/Labeling/BatchUpload";
import { TEAAI_S3_BUCKET } from "src/constants";
const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

// Dashboards
const TeaRetinaAnalysis = Loader(
  lazy(() => import("src/content/dashboards/tearetina"))
);
const SellingMarks = Loader(
  lazy(() => import("src/content/dashboards/selling-marks"))
);

const BenchmarkAnalysis = Loader(
  lazy(() => import("src/content/dashboards/benchmark"))
);
const BenchmarkResults = Loader(
  lazy(() => import("src/content/dashboards/benchmark/benchmarkResults"))
);
const BenchmarkJobs = Loader(
  lazy(() => import("src/content/dashboards/benchmark/benchmarkJobs"))
);
const DeploymentJobs = Loader(
  lazy(() => import("src/content/applications/ModelDeployment/deploymentJobs"))
);
const Models = Loader(
  lazy(() => import("src/content/dashboards/benchmark/Models"))
);
const Demo = Loader(lazy(() => import("src/content/dashboards/demo")));

//Labeling tool
const LabelingFileUpload = Loader(
  lazy(() => import("src/content/applications/LabelingTool/upload"))
);
const LabelingInterface = Loader(
  lazy(() => import("src/content/applications/LabelingTool/interface"))
);
const LabelingAssignedFiles = Loader(
  lazy(() => import("src/content/applications/LabelingTool/files/assigned"))
);
const LabelingAllFiles = Loader(
  lazy(() => import("src/content/applications/LabelingTool/files/all"))
);

// Applications
const DensityLabeling = Loader(
  lazy(() => import("src/content/applications/DensityLabeling"))
);

const UserManagement = Loader(
  lazy(() => import("src/content/applications/Users"))
);

const UserCreation = Loader(
  lazy(() => import("src/content/applications/Users/Registration"))
);

const UserGroupCreation = Loader(
  lazy(
    () =>
      import("src/content/applications/Users/UserGroups/UserGroupRegistration")
  )
);
const UploadMarketReport = Loader(
  lazy(() => import("src/content/applications/MarketReport"))
);
const UserGroups = Loader(
  lazy(() => import("src/content/applications/Users/UserGroups"))
);

const SignIn = Loader(lazy(() => import("src/content/signin/Signin")));

const ForgotPassword = Loader(
  lazy(() => import("src/content/signin/ForgotPassword"))
);

const VerifyUser = Loader(lazy(() => import("src/content/signin/VerifyUser")));

const ResetUser = Loader(lazy(() => import("src/content/signin/ResetUser")));

const UserProfile = Loader(
  lazy(() => import("src/content/applications/Users/profile"))
);
const UserSettings = Loader(
  lazy(() => import("src/content/applications/Users/settings"))
);

const FileUpload = Loader(
  lazy(() => import("src/content/applications/Fileupload"))
);

const FileUploadTask = Loader(
  lazy(() => import("src/content/applications/FileuploadTask"))
);

const ModelDeployment = Loader(
  lazy(() => import("src/content/applications/ModelDeployment"))
);
const AuditTable = Loader(lazy(() => import("src/content/applications/Audit")));

const ClientManagement = Loader(
  lazy(() => import("src/content/applications/Clients/Management/index"))
);

const CatalogTextFileUpload = Loader(
  lazy(() => import("src/content/applications/CatalogTextFileUpload"))
);

// Status
const Status404 = Loader(
  lazy(() => import("src/content/pages/Status/Status404"))
);
const Status500 = Loader(
  lazy(() => import("src/content/pages/Status/Status500"))
);
const StatusComingSoon = Loader(
  lazy(() => import("src/content/pages/Status/ComingSoon"))
);
const StatusMaintenance = Loader(
  lazy(() => import("src/content/pages/Status/Maintenance"))
);

const TeaRetinaImages = Loader(
  lazy(() => import("src/content/applications/Images"))
);

//Tools

const BatchSelection = Loader(
  lazy(() => import("src/content/applications/Labeling/BatchSelection"))
);

const Labeling = Loader(
  lazy(() => import("src/content/applications/Labeling/LabelingInterface"))
);

const Environments = Loader(
  lazy(() => import("src/content/dashboards/control-center/envrionments/"))
);

const MixingDashboard = Loader(
  lazy(() => import("src/content/dashboards/mixing-samples"))
);

const LotProgressDashboard = Loader(
  lazy(() => import("src/content/dashboards/LotProgress"))
);

const AnnotationTool = Loader(
  lazy(() => import("src/content/applications/AnnotationTool"))
);

const DataTransfer = Loader(
  lazy(() => import("src/content/dashboards/control-center/data-transfer/"))
);

const routes: RouteObject[] = [
  {
    path: "",
    element: <BaseLayout />,
    children: [
      {
        path: "/",
        element: <SignIn />,
      },
      {
        path: "/signin",
        element: <Navigate to="/" replace />,
      },
      {
        path: "/forgotpassword",
        element: <ForgotPassword />,
      },
      {
        path: "/verifyuser",
        element: <VerifyUser />,
      },
      {
        path: "/resetuser",
        element: <ResetUser />,
      },
      {
        path: "status",
        children: [
          {
            path: "",
            element: <Navigate to="404" replace />,
          },
          {
            path: "404",
            element: <Status404 />,
          },
          {
            path: "500",
            element: <Status500 />,
          },
          {
            path: "maintenance",
            element: <StatusMaintenance />,
          },
          {
            path: "coming-soon",
            element: <StatusComingSoon />,
          },
        ],
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "dashboards",
    element: <SidebarLayout />,
    children: [
      {
        path: "",
        element: <Navigate to="tearetina" replace />,
      },
      {
        path: "tearetina",
        element: (
          <ProtectedRoute
            component={<TeaRetinaAnalysis />}
            name={"TeaRetinaAnalysis"}
          />
        ),
      },
      {
        path: "selling-marks",
        element: (
          <ProtectedRoute component={<SellingMarks />} name={"SellingMarks"} />
        ),
      },
      {
        path: "density-labeling",
        element: (
          <ProtectedRoute
            component={<DensityLabeling />}
            name={"DensityLabeling"}
          />
        ),
      },
      {
        path: "benchmark",
        children: [
          {
            path: "",
            element: <Navigate to="analysis" replace />,
          },
          {
            path: "analysis",
            element: (
              <ProtectedRoute
                component={<BenchmarkAnalysis />}
                name={"BenchmarkAnalysis"}
              />
            ),
          },
          {
            path: "models",
            element: <ProtectedRoute component={<Models />} name={"Models"} />,
          },
          {
            path: "results",
            element: (
              <ProtectedRoute
                component={<BenchmarkResults />}
                name={"BenchmarkResults"}
              />
            ),
          },
          {
            path: "jobs",
            element: (
              <ProtectedRoute
                component={<BenchmarkJobs />}
                name={"BenchmarkJobs"}
              />
            ),
          },
        ],
      },
      {
        path: "deploy",
        children: [
          {
            path: "",
            element: <Navigate to="deploy-models" replace />,
          },

          {
            path: "deploy-models",
            element: (
              <ProtectedRoute
                component={<ModelDeployment />}
                name={"ModelDeployment"}
              />
            ),
          },
          {
            path: "jobs",
            element: (
              <ProtectedRoute
                component={<DeploymentJobs />}
                name={"BenchmarkJobs"}
              />
            ),
          },
        ],
      },
    ],
  },
  {
    path: "tearetina",
    element: <SidebarLayout header={"General"} />,
    children: [
      {
        path: "images",
        element: (
          <ProtectedRoute
            component={<TeaRetinaImages />}
            name={"TeaRetinaImages"}
          />
        ),
      },
    ],
  },
  {
    path: "labeling",
    element: <SidebarLayout header={"Labeling"} />,
    children: [
      {
        path: "",
        element: <Navigate to="upload" replace />,
      },
      {
        path: "upload",
        element: (
          <ProtectedRoute
            component={<LabelingFileUpload />}
            name={"LabelingFileUpload"}
          />
        ),
      },
      {
        path: "files/assigned",
        element: (
          <ProtectedRoute
            component={<LabelingAssignedFiles />}
            name={"LabelingAssignedFiles"}
          />
        ),
      },
      {
        path: "files/assigned/:file_id/:record_id",
        element: (
          <ProtectedRoute
            component={<LabelingInterface />}
            name={"LabelingInterface"}
          />
        ),
      },
      {
        path: "files/all",
        element: (
          <ProtectedRoute
            component={<LabelingAllFiles />}
            name={"LabelingAllFiles"}
          />
        ),
      },
    ],
  },
  {
    path: "file-management",
    element: <SidebarLayout header={"General"} />,
    children: [
      {
        path: "catalogs",
        element: (
          <ProtectedRoute
            component={
              <FileUpload
                props={{
                  title: "catalog",
                  tableName: "CatalogCollection",
                  keyPath: "catalogs",
                  bucketName: process.env.REACT_APP_S3_TEABRAIN,
                  stepFunctionName: "CATALOG_UPLOAD_SF_ARN",
                  api: process.env.REACT_APP_S3_TEABRAIN,
                  apiPath: "auction-catalog",
                  mapper: [
                    {
                      Source: "Year",
                      DType: "int",
                      Destination: "year",
                    },
                    {
                      Source: "Sale Code",
                      DType: "int",
                      Destination: "sale_code",
                    },
                    {
                      Source: "Broker Code",
                      DType: "string",
                      Destination: "broker_code",
                    },
                    {
                      Source: "Broker",
                      DType: "string",
                      Destination: "broker",
                    },
                    {
                      Source: "Category",
                      DType: "string",
                      Destination: "category",
                    },
                    {
                      Source: "Factory",
                      DType: "int",
                      Destination: "factory",
                    },
                    {
                      Source: "Selling Mark - MF Mark",
                      DType: "string",
                      Destination: "selling_mark",
                    },
                    {
                      Source: "Lot No",
                      DType: "int",
                      Destination: "lot_no",
                    },
                    {
                      Source: "Reprint",
                      DType: "string",
                      Destination: "re_print",
                    },
                    {
                      Source: "Bags",
                      DType: "string",
                      Destination: "bags",
                    },
                    {
                      Source: "Net Weight",
                      DType: "int",
                      Destination: "net_weight",
                    },
                    {
                      Source: "Grade",
                      DType: "string",
                      Destination: "grade",
                    },
                    {
                      Source: "Invoice No",
                      DType: "string",
                      Destination: "invoice_no",
                    },
                    {
                      Source: "Rainforest",
                      DType: "string",
                      Destination: "rain_forest",
                    },
                    {
                      Source: "Certifications",
                      DType: "string",
                      Destination: "certificate_names",
                    },
                    {
                      Source: "Sale Date",
                      DType: "string",
                      Destination: "sale_date",
                    },
                    {
                      Source: "Total Weight",
                      DType: "int",
                      Destination: "total_weight",
                    },
                  ],
                }}
              />
            }
            name={"FileUpload"}
          />
        ),
      },
      {
        path: "market-report",
        element: (
          <ProtectedRoute
            component={
              <UploadMarketReport
                props={{
                  keyPath: "market_data",
                }}
              />
            }
            name={"FileUpload"}
          />
        ),
      },

      {
        path: "taster-notes",
        element: (
          <ProtectedRoute
            component={
              <FileUpload
                props={{
                  title: "taster-notes",
                  tableName: "TasterNoteCollection",
                  keyPath: "taster-notes",
                  bucketName: process.env.REACT_APP_S3_TEABRAIN,
                  stepFunctionName: "TASTER_NOTE_UPLOAD_SF_ARN",
                  api: process.env.REACT_APP_S3_TEABRAIN,
                  apiPath: "auction-catalog",
                  mapper: [
                    {
                      Source: "year",
                      DType: "int",
                      Destination: "year",
                    },
                    {
                      Source: "sale_code",
                      DType: "int",
                      Destination: "sale_code",
                    },
                    {
                      Source: "broker_code",
                      DType: "string",
                      Destination: "broker_code",
                    },
                    {
                      Source: "broker_name",
                      DType: "string",
                      Destination: "broker_name",
                    },
                    {
                      Source: "lot_no",
                      DType: "int",
                      Destination: "lot_no",
                    },
                    {
                      Source: "trader_name",
                      DType: "string",
                      Destination: "trader_name",
                    },
                    {
                      Source: "catalog_name",
                      DType: "string",
                      Destination: "catalog_name",
                    },
                    {
                      Source: "visual_stds",
                      DType: "string",
                      Destination: "visual_stds",
                    },
                    {
                      Source: "visual_remarks",
                      DType: "string",
                      Destination: "visual_remarks",
                    },
                    {
                      Source: "liquor_stds",
                      DType: "string",
                      Destination: "liquor_stds",
                    },
                    {
                      Source: "liquor_remarks",
                      DType: "string",
                      Destination: "liquor_remarks",
                    },
                    {
                      Source: "cross",
                      DType: "boolean",
                      Destination: "cross",
                    },
                    {
                      Source: "no_sample",
                      DType: "boolean",
                      Destination: "no_sample",
                    },
                    {
                      Source: "discard",
                      DType: "boolean",
                      Destination: "discard",
                    },
                    {
                      Source: "withdraw",
                      DType: "boolean",
                      Destination: "withdraw",
                    },
                    {
                      Source: "moisture",
                      DType: "boolean",
                      Destination: "moisture",
                    },
                    {
                      Source: "unsure",
                      DType: "boolean",
                      Destination: "unsure",
                    },
                  ],
                }}
              />
            }
            name={"FileUpload"}
          />
        ),
      },
      {
        path: "batches",
        element: (
          <ProtectedRoute
            component={<BatchUpload props={{ title: "Label File Upload" }} />}
            name="BatchUpload"
          />
        ),
      },
      {
        path: "text-file-upload",
        element: (
          <ProtectedRoute
            component={<CatalogTextFileUpload />}
            name={"CatalogTextFileUpload"}
          />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "user-management",
    element: <SidebarLayout header={"General"} />,
    children: [
      {
        path: "view",
        element: (
          <ProtectedRoute
            component={<UserManagement />}
            name={"UserManagement"}
          />
        ),
      },
      {
        path: "user-groups",
        element: (
          <ProtectedRoute
            component={<UserGroups props={{ title: "User Groups" }} />}
            name={"UserGroups"}
          />
        ),
      },
      {
        path: "register-user-group",
        element: (
          <ProtectedRoute
            component={<UserGroupCreation />}
            name={"UserGroupCreation"}
          />
        ),
      },
      {
        path: "register-user",
        element: (
          <ProtectedRoute component={<UserCreation />} name={"UserCreation"} />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "management",
    element: <SidebarLayout header={"General"} />,
    children: [
      {
        path: "profile",
        children: [
          {
            path: "",
            element: <Navigate to="details" replace />,
          },
          {
            path: "details",
            element: <UserProfile />,
          },
          {
            path: "settings",
            element: <UserSettings />,
          },
          {
            path: "*",
            element: <Status404 />,
          },
        ],
      },
    ],
  },
  {
    path: "user-management",
    element: <SidebarLayout header={"General"} />,
    children: [
      {
        path: "view",
        element: (
          <ProtectedRoute
            component={<UserManagement />}
            name={"UserManagement"}
          />
        ),
      },
      {
        path: "register-user",
        element: (
          <ProtectedRoute component={<UserCreation />} name={"UserCreation"} />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "clients",
    element: <SidebarLayout header={"General"} />,
    children: [
      {
        path: "management",
        element: (
          <ProtectedRoute
            component={<ClientManagement />}
            name={"ClientManagement"}
          />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "audit",
    element: <SidebarLayout />,
    children: [
      {
        path: "view-upload-tasks",
        element: (
          <ProtectedRoute
            component={<FileUploadTask />}
            name={"FileUploadTask"}
          />
        ),
      },
      {
        path: "user-actions",
        element: (
          <ProtectedRoute component={<AuditTable />} name={"AuditTable"} />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "management",
    element: <SidebarLayout header={"General"} />,
    children: [
      {
        path: "profile",
        children: [
          {
            path: "",
            element: <Navigate to="details" replace />,
          },
          {
            path: "details",
            element: <UserProfile />,
          },
          {
            path: "settings",
            element: <UserSettings />,
          },
          {
            path: "*",
            element: <Status404 />,
          },
        ],
      },
    ],
  },
  {
    path: "demo",
    element: <ProtectedRoute component={<Demo />} name={"Demo"} />,
  },
  {
    path: "/health",
    element: <h1>passed health</h1>,
  },
  {
    path: "tools",
    element: <SidebarLayout header={"TeaRetina"} />,
    children: [
      {
        path: "",
        element: <Navigate to="labeling" replace />,
      },
      {
        path: "labeling",
        element: (
          <ProtectedRoute
            component={
              <BatchSelection props={{ title: "Label File Selection" }} />
            }
            name={"BatchSelection"}
          />
        ),
      },
      {
        path: "labeling/:id/:item_id",
        element: (
          <ProtectedRoute
            component={<Labeling props={{ title: "Labeling" }} />}
            name={"Labeling"}
          />
        ),
      },
      {
        path: "annotation/*",
        element: <AnnotationTool />,
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "control-center",
    element: <SidebarLayout header={"Control Center"} />,
    children: [
      {
        path: "",
        element: <Navigate to="environments" replace />,
      },
      {
        path: "environments",
        element: (
          <ProtectedRoute component={<Environments />} name={"Environments"} />
        ),
      },
      {
        path: "data-transfer",
        element: (
          <ProtectedRoute component={<DataTransfer />} name={"DataTransfer"} />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "mixing-dashboard",
    element: <SidebarLayout header={"Mixing Dashboard"} />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            component={<MixingDashboard />}
            name={"MixingDashboard"}
          />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "lot-progress",
    element: <SidebarLayout header={"LotProgressDashboard"} />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            component={<LotProgressDashboard />}
            name={"LotProgressDashboard"}
          />
        ),
      },
      {
        path: "*",
        element: <Status404 />,
      },
    ],
  },
  {
    path: "/test-annotation",
    element: <AnnotationTool />,
  },
];

export default routes;
